/**
 * Resolves the SRC-20 registry entry for a given chainId.
 * Returns `undefined` when the chain has no registry entry or is disabled.
 */
import { useMemo } from 'react'
import useChainId from '@/hooks/useChainId'
import { getSrc20Config } from '../registry'
import type { Src20ChainConfig } from '../registry'

export const useSrc20Config = (chainIdOverride?: string | number): Src20ChainConfig | undefined => {
  const currentChainId = useChainId()
  const chainId = chainIdOverride ?? currentChainId
  return useMemo(() => getSrc20Config(chainId), [chainId])
}

export default useSrc20Config
